<template>
  <div
    class="w-full border-b last:border-b-0 border-gray-100 text-xs py-1 text-gray-800"
    :class="toobig || hasError ? 'text-red-700' : 'text-gray-800'"
  >
    <div class="flex items-center">
      <span class="pr-1 text-sm w-6"
        ><font-awesome-icon :icon="icon"></font-awesome-icon
      ></span>
      <div class="w-12 whitespace-no-wrap" v-text="size"></div>
      <div v-text="file.name" class="flex-1"></div>
      <div
        class="p-2 cursor-pointer"
        @click="$emit('remove')"
        v-tooltip="closeLabel"
      >
        <font-awesome-icon icon="times-circle"></font-awesome-icon>
      </div>
    </div>
    <div class="">
      <div
        class="px-2 text-red-700 flex flex-col"
        v-if="hasError"
        v-html="error"
      ></div>
    </div>
  </div>
</template>

<script>
import prettierBytes from "prettier-bytes";

export default {
  props: ["file", "error", "closeLabel"],
  components: {},
  mixins: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    name() {
      return this.file.name;
    },
    type() {
      return this.file.type.split("/").shift();
    },
    extension() {
      return this.file.name.split(".").pop();
    },
    icon() {
      if (this.type === "image") {
        return "file-image";
      }

      if (this.extension === "zip") {
        return "file-archive";
      }

      if (this.extension === "pdf") {
        return "file-pdf";
      }

      return "file";
    },
    size() {
      return prettierBytes(this.file.size);
    },
    toobig() {
      return this.file.size > 5000000; // 5MB
    },
    hasError() {
      return this.error != undefined && this.error != "";
    },
  },
  mounted() {},
};
</script>
